import { postTagUnlink } from '@api';
import { refreshCurrentInitiativeTagsSaga } from '../../initiatives/tags/get';
import { updateSonarObjectReferences } from '../../sonar-objects/_idMap/actions';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTagsUnlinkPostAsyncSlice = createPostAsyncSlice({
	additionalReceiveSteps: [
		{
			actionHandler: refreshCurrentInitiativeTagsSaga,
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateSonarObjectReferences([
					{
						sonarObjectId: request.sonarObjectId,
						tags: {
							toRemove: request.sonarObjectTagId
						}
					}
				])
		]
	},
	name: 'CoreTagsUnlink',
	receive: false,
	request: true,
	requestHandler: postTagUnlink,
	yieldType: SagaYieldType.Every
});
